// The Gmail link's wire calls: the account page's Gmail row reads
// `GET /api/gmail/link` and ends a link with `DELETE /api/gmail/link`; a link
// starts with a full-page navigation to `/auth/gmail/start` (Google's sign-in),
// which lands back on `/account?gmail=<marker>`.

import { GmailLinkStatusSchema, type GmailLinkStatus } from "@loom/shared/gmail";

import { httpDelete, httpGet } from "../lib/http";

export const GMAIL_LINK_START_HREF = "/auth/gmail/start";

/** The query key `/auth/gmail/callback` lands on `/account` with. */
export const GMAIL_RESULT_PARAM = "gmail";

export const readGmailLink = (): Promise<GmailLinkStatus> =>
  httpGet("/api/gmail/link", GmailLinkStatusSchema);

export const unlinkGmail = (): Promise<void> => httpDelete("/api/gmail/link");
